import { WebStorageStateStore } from "oidc-client-ts";
import { getKeycloakRedirectUri, getPostLogoutRedirectUri } from "../helpers/keycloakAuth";

const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM;
const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

const oidcConfig = {
  authority: `${keycloakUrl}/realms/${keycloakRealm}`,
  client_id: keycloakClientId,
  redirect_uri: getKeycloakRedirectUri(),
  post_logout_redirect_uri: getPostLogoutRedirectUri(),
  response_type: "code",
  scope: "openid profile email offline_access",
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export default oidcConfig;
